import axios from 'axios'
import createRequest from '@chordcommerce/chord-js-autonomy/dist/oms/request'
import { createRequestConfig } from '@chordcommerce/chord-js-autonomy/dist/oms'

const omsClientConfig = {
  brandName: process.env.GATSBY_CHORD_OMS_BRAND_NAME,
  storeId: process.env.GATSBY_CHORD_OMS_STORE_ID,
  omsId: process.env.GATSBY_CHORD_OMS_ID,
  tenantId: process.env.GATSBY_CHORD_OMS_TENANT_ID,
  domain: process.env.GATSBY_CHORD_OMS_API_URL,
}

export const addTagsToOrder = async (authToken, order, data) => {
  const url = `/api/tags/add_to/${order.number}`
  const request = createRequest(omsClientConfig)
  const config = createRequestConfig({ authToken, orderToken: order.token })
  const response = await request.put(url, data, config)
  return response.data
}

export const removeTagsFromOrder = async (authToken, order, data) => {
  const url = `/api/tags/remove_from/${order.number}`
  const request = createRequest(omsClientConfig)
  const config = createRequestConfig({ authToken, orderToken: order.token })
  const response = await request.put(url, data, config)
  return response.data
}

export const updateSubscriptionPreferences = (params) =>
  axios
    .post(`/.netlify/functions/chord-up-sub-prefs`, null, { params })
    .then((response) => response.status)
